import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function getExperianResultsService(caseManagerId) {
  return axiosRequest('get', serviceUrls.GET_EXPERIAN_RESULTS + '/' + caseManagerId, {}, { timeout: 180000 });
}

export function getExperianBgCheckResultsService(caseManagerId) {
  return axiosRequest('get', serviceUrls.GET_EXPERIAN_BGCHECK_RESULTS + '/' + caseManagerId, {}, { timeout: 180000 });
}

export function getExperianPDFService(caseManagerId) {
  return axiosRequest('get', serviceUrls.GET_EXPERIAN_PDF + '/' + caseManagerId, {}, { timeout: 180000 });
}

export function getExperianTestExportToPDFService(testImageId) {
  return axiosRequest('get', serviceUrls.GET_EXPERIAN_TEXT_TO_PDF + '/' + testImageId, {}, { timeout: 180000 });
}

export function personProfilePdfByResourceCodeSvc(resID, qrCode) {
  return axiosRequest('get', serviceUrls.GET_PERSON_PROFILE_PDF_BY_RESCODE + resID, {}, { timeout: 180000 });
}

export function updateBackgroundCheckDetailSvc(payload) {
  return axiosRequest('post', serviceUrls.UPDATE_BG_CHECK_DETAIL, payload, { timeout: 180000 });
}
